import { useState } from "react";
import "../css/Login.css";

export default function Login({ isLoggedIn, setProfile }) {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    async function handleLogin() {
        try {
            const response = await fetch(
                "https://anagrams.ca/api/account/login",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    credentials: "include",
                    body: JSON.stringify({
                        username,
                        password
                    })
                }
            );

            const data = await response.json();
            const profile = data.profile;
            console.log(data)
            console.log(data["profile"])
            console.log(profile)
            if (response.ok) {
                isLoggedIn(true)
                console.log("Login successful: ");
                console.log(data)
                setProfile({ username: profile.username, displayName: profile.displayName, pfp: profile.pfp })


            }
            else {
                alert(data.error);
            }
        }
        catch (error) {
            console.error(error);
        }
    }
    async function handleCreateAccount() {
        try {
            const response = await fetch(
                "https://anagrams.ca/api/account/create",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    credentials: "include",
                    body: JSON.stringify({
                        username,
                        password
                    })
                }
            );

            const data = await response.json();

            console.log(data);

            if (response.ok) {
                handleLogin()
                alert(
                    "Account created successfully"
                );
            }
            else {
                alert(data.error);
            }
        }
        catch (error) {
            console.error(error);
        }
    }
    return (
        <div className="login-container">
            <div className="login-tile">
                <h1>Login</h1>

                <input
                    type="text"
                    placeholder="Username"
                    value={username}
                    onChange={(e) =>
                        setUsername(e.target.value)
                    }
                />

                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) =>
                        setPassword(e.target.value)
                    }
                />


                <button
                    className="login-button"
                    onClick={handleLogin}
                >
                    Login
                </button>

                <button
                    className="create-account-button"
                    onClick={handleCreateAccount}
                >
                    Create Account
                </button>



            </div>
        </div>
    );
}
